<template>
  <div class="container">
    <b-overlay :show="apiRslt.fetch.inProgress" rounded="sm" opacity="0.5" blur="none">
      <div class="row gutters">
        <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
          <div class="card h-100">
            <div class="card-body">
              <div class="account-settings">
                <div class="user-profile">
                  <b-avatar size="90px" class="my-4"></b-avatar>
                  
                  <h5 class="user-name" v-if="fullUser.firstname && fullUser.lastname">{{ fullUser.firstname }} {{ fullUser.lastname }}</h5>
                  <h6 class="user-email" v-if="fullUser.email">{{ fullUser.email }}</h6>
                  <h5 class="user-name text-danger" v-else>Compléter votre profile</h5>
                </div>
                <div class="about">
                  <h5>Alerte notifications</h5>
                  <p>
                    <span v-for="subscription in fullUser.subscriptions" :key="subscription" class="badge badge-secondary">
                      {{ subscription }}
                    </span>
                  </p>
                  

                  <h5>Rôle(s)</h5>
                  <p>
                    <span v-for="role in fullUser.roles" :key="role" class="badge badge-secondary">
                      {{ role }}
                    </span>
                  </p>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12">
          <div class="card h-100">
            <div class="card-body">
              <div class="row gutters">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <h6 class="mb-2 text-primary">Informations personnelles</h6>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <text-field
                        disabled
                        name="Login"
                        property="username"
                        v-model="$v.form.username.$model"
                    />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <email-field
                        name="Email"
                        property="email"
                        v-model="$v.form.email.$model"
                        :error="$v.form.email.$error"
                        errorCode="MESS001"
                    />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <text-field
                      name="Nom"
                      property="lastname"
                      v-model="$v.form.lastname.$model"
                      :error="$v.form.lastname.$error"
                        errorCode="MESS001"
                  />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <text-field
                      name="Prénom"
                      property="firstname"
                      v-model="$v.form.firstname.$model"
                      :error="$v.form.firstname.$error"
                        errorCode="MESS001"
                  />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <text-field
                      name="Téléphone"
                      property="phone"
                      v-model="$v.form.phone.$model"
                      :error="$v.form.phone.$error"
                        errorCode="MESS001"
                  />
                </div>
              </div>
              <div class="row gutters">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <h6 class="mt-3 mb-2 text-primary">Adresse</h6>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12">
                    <text-field
                        name="Numéro"
                        property="number"
                        v-model="$v.form.address.number.$model"
                        :error="$v.form.address.number.$error"
                        errorCode="MESS001"
                    />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <text-field
                        name="Rue"
                        property="street"
                        v-model="$v.form.address.street.$model"
                        :error="$v.form.address.street.$error"
                        errorCode="MESS001"
                    />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                  <text-field
                        name="Ville"
                        property="city"
                        v-model="$v.form.address.city.$model"
                        :error="$v.form.address.city.$error"
                        errorCode="MESS001"
                    />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <text-field
                        name="Pays"
                        property="country"
                        v-model="$v.form.address.country.$model"
                        :error="$v.form.address.country.$error"
                        errorCode="MESS001"
                    />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <text-field
                        name="Code Postal"
                        property="zipcode"
                        v-model="$v.form.address.zipcode.$model"
                        :error="$v.form.address.zipcode.$error"
                        errorCode="MESS001"
                    />
                </div>
              </div>
              <div class="row gutters">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-5">
                  <div class="text-right">
                    <button class="btn btn-danger float-left" style="border-radius: 0px;" @click="reset()">Annuler</button>
                    <button class="btn btn-primary float-right" style="border-radius: 0px;" @click="updated()">Mettre à jour</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { EmailField, TextField } from "@/core/components/form";
import { mapState, mapActions } from 'vuex';
import { required } from "vuelidate/lib/validators"


export default {
  name: 'Users',
  components: { TextField, EmailField },
  computed: {
    ...mapState('auth',['fullUser','user']),
    ...mapState('users',['apiRslt'])
  },
  created() {
    this.form = { 
        id: this.fullUser.id ? this.fullUser.id : "",
        username: this.fullUser.username ? this.fullUser.username : "", 
        email: this.fullUser.email ? this.fullUser.email : "", 
        address: this.fullUser.address ? this.fullUser.address : {street:"",number:"",city:"",zipcode:"",country:""}, 
        firstname: this.fullUser.firstname ? this.fullUser.firstname : "", 
        lastname: this.fullUser.lastname ? this.fullUser.lastname : "",  
        phone: this.fullUser.phone ? this.fullUser.phone : ""
    }

  },
  data() {
    return {
      form:{
        username: "", 
        email: "", 
        firstname: "", 
        lastname: "", 
        address: {
          street: "",
          number: "",
          city: "",
          zipcode: "",
          country: ""
        }, 
        phone: ""
      },
    }
  },
  methods: {
    ...mapActions('users',['updateUser']),
    ...mapActions('auth',['updateFullUser']),
    updated(){
      this.$v.form.$reset()
      this.$v.form.$touch()
      if(!this.$v.form.$error){
        this.updateUser(this.form)
        this.updateFullUser(this.form)
      }
    },
    reset(){
      location.reload()
    }
  },
  validations: {
    form:{
        username: { required }, 
        email: { required }, 
        firstname: {}, 
        lastname: {}, 
        address: {
          street: {},
          number: {},
          city: {},
          zipcode: {},
          country: {}
        }, 
        phone: {}
    }
  }
}
</script>

<style scoped>

.account-settings .user-profile {
    margin: 0 0 1rem 0;
    padding-bottom: 1rem;
    text-align: center;
}
.account-settings .user-profile .user-avatar {
    margin: 0 0 1rem 0;
}
.account-settings .user-profile .user-avatar img {
    width: 90px;
    height: 90px;
    -webkit-border-radius: 100px;
    -moz-border-radius: 100px;
    border-radius: 100px;
}
.account-settings .user-profile h5.user-name {
    margin: 0 0 0.5rem 0;
}
.account-settings .user-profile h6.user-email {
    margin: 0;
    font-size: 0.8rem;
    font-weight: 400;
    color: #9fa8b9;
}
.account-settings .about {
    margin: 2rem 0 0 0;
    text-align: center;
}
.account-settings .about h5 {
    margin: 0 0 15px 0;
    color: #007ae1;
}
.account-settings .about p {
    font-size: 0.825rem;
}
.form-control {
    border: 1px solid #cfd1d8;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    border-radius: 2px;
    font-size: .825rem;
    background: #ffffff;
    color: #2e323c;
}

.card {
    background: #ffffff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    border: 0;
    margin-bottom: 1rem;
}

</style>
